import { Button, ChevronDown, Select } from "@ptsd/uikit";
import { useTranslation } from "react-i18next";
import { Text, XStack } from "tamagui";

import { useSlicesResultsFilterContext } from "./context";

export const SlicesFilter = () => {
  const { t } = useTranslation("filters");
  const { filter, dispatch, options } = useSlicesResultsFilterContext();
  if (options.length === 0) return null;
  return (
    <XStack alignItems="center" gap={"$1"}>
      <Text
        color={"$gray-primary-900"}
        fontFamily={"$subtitle"}
        fontWeight={"$5"}
        fontSize={"$2"}
        lineHeight={"$2"}
      >
        {t("slices-filter.label")}
      </Text>

      <Select
        value={filter.slice ?? ""}
        onValueChange={(val) => {
          dispatch({
            type: "SET_FILTER",
            filterName: "slice",
            value: val,
          });
        }}
        items={options}
        trigger={(Value) => (
          <Button width={"100%"} variant="gray" size={"sm"} rounded="lg">
            <XStack gap={"$1"} alignItems="center">
              <Value
                fontFamily={"$subtitle"}
                fontWeight={"$5"}
                fontSize={"$2"}
                lineHeight={"$2"}
                color={"$gray-primary-900"}
              />
              <ChevronDown />
            </XStack>
          </Button>
        )}
      />
    </XStack>
  );
};
